import { render } from "./EditCustomer.vue?vue&type=template&id=78f08336"
import script from "./EditCustomer.vue?vue&type=script&lang=js"
export * from "./EditCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__